<template>
  <div class="wrapper-content w-100">
    <h1 v-if="isOnEditMode">Edición {{form.titulo}}</h1>
    <h1 v-if="!isOnEditMode">Nuevo {{form.titulo}}</h1>
    <LmForm ref="lmFormRef">
      <div class="row">
        <LmTextInput class="col-12"
        v-model="form.titulo"
        label="Título"
        :v="$v.form.titulo" />
      </div>

      <div class="row">
        <LmTextInput class="col-12"
        v-model="form.link_sorteo"
        label="Link Sorteo"
        :v="$v.form.link_sorteo" />
      </div>

      <div class="row">
            <LmEditor
                ref="lmEditorSeccionVisto"
                class="col-12"
                @onUpdate="form.terminos_y_condiciones = $event"
                label="Términos y Condiciones"
                :v="$v.form.terminos_y_condiciones"
                :contentProps="form.terminos_y_condiciones"
                :activeTable="false"
            />
        </div>

      <LmImagenPages v-model="options" v-show="options.image" @fileRemoved="fileRemoved" class="my-2 mb-4" />

         <LmUploadFiles
            label="Imagen"
            ref="lmUploadFiles"
            class="mb-3"
            :dropzoneOptions="dropzoneOptions"
            dictDefaultMessage='Arrastre la imagen acá para subirla'
            :v="$v.form.imagen"
            @vdropzone-removed-file="fileRemoved"
            @vdropzone-success="fileCreated"
            v-show="!options.image"
        />

        <LmDateTime
        ref="fecha_inicio"
        v-model="form.fecha_inicio"
        :config="lmDateTimeConfig"
        :v="$v.form.fecha_inicio"
        placeholder="Fecha Inicio"
        label="Fecha Inicio"
        />

        <LmDateTime
        v-model="form.fecha_fin"
        :config="lmDateTimeConfig"
        :v="$v.form.fecha_fin"
        placeholder="Fecha Fin"
        label="Fecha Fin"
        />
  <div class="mt-5">
   <LmButton
        id="btn-cancel"
        type="button"
        buttonClass="btn-secondary"
        :isProcessing="formIsProcessing"
        :value="$t('Cancel')"
        @click.native="cancelBtn"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        />

        <LmButton
            type="submit"
            buttonClass="btn-success"
            :isProcessing="formIsProcessing"
            :value="$t('Save')"
            lmButtonRootWrapperClass="d-inline-block mr-1"
            lmButtonWrapperClass="col"
            @click.native="submit('guardar')"
        />

        <LmButton
            type="submit"
            buttonClass="btn-primary"
            :isProcessing="formIsProcessing"
            :value="$t('Guardar y salir')"
            lmButtonRootWrapperClass="d-inline-block mr-1"
            lmButtonWrapperClass="col"
            @click.native="submit('guardarSalir')"
        />
    </div>

    </LmForm>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import axios from 'axios'
import store from '@/store'
import { Spanish } from 'flatpickr/dist/l10n/es.js'

import LmForm from '@/components/form/LmForm.vue'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmUploadFiles from '@/components/LmUploadFiles'
import LmButton from '@/components/form/elements/LmButton.vue'
import LmImagenPages from '@/views/365/pages/elements/LmImagenPages'
import LmEditor from '@/components/form/elements/lmEditor'
import LmDateTime from '@/components/form/elements/LmDateTime.vue'

export default {
  components: {
    LmForm,
    LmTextInput,
    LmUploadFiles,
    LmButton,
    LmImagenPages,
    LmEditor,
    LmDateTime
  },
  data () {
    return {
      form: {
        titulo: '',
        imagen: null,
        fecha_inicio: null,
        terminos_y_condiciones: null,
        fecha_fin: null,
        state: null
      },
      initialForm: {},
      files: [],
      formIsProcessing: false,
      lmDateTimeConfig: {
        dateFormat: 'Y-m-d H:i',
        locale: Spanish,
        allowInput: true,
        enableTime: true,
        minDate: 'today'
      },
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}documentos/nuevo/`,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null,
          Authorization: `Bearer ${store.state.session.accessToken}`
        },
        withCredentials: true,
        thumbnailWidth: 150,
        maxFiles: 1,
        addRemoveLinks: true,
        acceptedFiles: 'image/*'
      },
      options: {
        type: Object,
        idRandom: '',
        id: '',
        titulo: '',
        image: '',
        imageOriginalName: '',
        imageSize: '',
        default: () => ({
          disabledOption: 'Seleccione una acción',
          content: []
        })
      }
    }
  },
  props: {
    titulo: {
      type: String,
      default: ''
    },
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async submit (guardarType) {
      try {
        await this.$refs.lmFormRef.validationForm(this.$v)
        this.formIsProcessing = true
        const fileLoaded = this.files.length ? this.files[0].path : ''
        const dataToSendToTheServer = {
          titulo: this.form.titulo,
          link_sorteo: this.form.link_sorteo,
          terminos_y_condiciones: this.form.terminos_y_condiciones,
          fecha_inicio: this.form.fecha_inicio,
          fecha_fin: this.form.fecha_fin,
          id: this.form.id,
          imagen: this.form.imagen || fileLoaded
        }

        let apiUrl = this.isOnEditMode ? `${process.env.VUE_APP_API_URL}sorteo/edit-sorteos/` : `${process.env.VUE_APP_API_URL}sorteo/new/`
        await axios.post(
          apiUrl,
          dataToSendToTheServer,
          {
            headers: {
              Authorization: `Bearer ${store.state.session.accessToken}`
            }
          }
        )

        if (guardarType === 'guardarSalir') {
          this.$router.push('/sorteos/listado')
        } else {
          this.makeToast('guardar')
          if (!this.isOnEditMode) {
            this.$nextTick(function () {
              this.$refs.lmEditorSeccionVisto.editor.commands.clearContent()
              this.form.titulo = null
              this.form.link_sorteo = null
              // this.form.fecha_inicio = null
              // this.form.fecha_fin = null
              this.$refs.lmUploadFiles.lmRemoveAllFiles()
              this.$v.$reset()
            })
          }
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.formIsProcessing = false
      }
    },
    makeToast (variant = null) {
      if (variant === 'guardar') {
        this.$bvToast.toast('El contenido se guardó exitosamente.', {
          title: `Mensaje`,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-bottom-center'
        })
      }
    },
    async setForm () {
      if (this.isOnEditMode) {
        await this.$refs.lmFormRef.activeEditMode({
          path: 'sorteo/read-sorteos',
          id: this.$route.params.id,
          paramsMode: true
        })
          .then(() => {
            if (this.form.imagen) {
              const fileOption = {
                size: 100000
              }
              this.$refs.lmUploadFiles.lmManuallyAddFile(fileOption, this.form.apiUrlPath + this.form.imagen)
              this.options.image = this.form.imagen
            }
          })
          .then(() => {
            this.$nextTick(function () {
              this.$v.$reset()
            })
          })
          .catch(error => {
            console.log(error)
            this.$router.replace({ name: '404' })
          })
      } else {
        this.form = JSON.parse(this.initialForm)
        this.$refs.lmFormRef.showLoading()
        this.$refs.lmUploadFiles.lmRemoveAllFiles()
        this.form.imagen = ''
        this.options.image = ''
        setTimeout(() => {
          this.$v.$reset()
          this.$refs.lmFormRef.hideLoading()
        }, 350)
      }
    },
    fileCreated (file, response) {
      if (response) {
        setTimeout(() => {
          this.options.idRandom = Math.random()
        }, 1000
        )
        // this.form.title = response.path
        this.form.imagen = response.path
        this.options.image = response.path
        this.options.link_sorteo = response.link_sorteo
        this.options.imageSize = this.bytesToSize(response.size)
        this.files.push(response)
      }
      this.$refs.lmUploadFiles.disable()
    },
    fileRemoved (file, error, xhr) {
      this.form.imagen = ''
      this.options.image = ''
      this.files = []
      if (file) {
        this.files = this.files.filter(f => f.originalname !== file.name)
      }
      this.$refs.lmUploadFiles.lmRemoveAllFiles()
      this.$refs.lmUploadFiles.enable()
    },
    cancelBtn () {
      this.$router.push('/sorteos/listado')
    },
    bytesToSize (bytes) {
      const sizes = ['bytes', 'kb', 'mb', 'gb', 'tb']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(Math.abs(bytes)) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
    }
  },
  validations: {
    form: {
      titulo: {
        required
      },
      link_sorteo: {
        required
      },
      imagen: {
        required
      },
      fecha_inicio: {
        required
      },
      fecha_fin: {
        required
      }
    }
  },
  watch: {
    isOnEditMode () {
      this.setForm()
    }
  },
  created () {
    this.initialForm = JSON.stringify(this.form)
  },
  mounted () {
    this.setForm()
  }
}
</script>

<style>

</style>
